import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography, Grid } from "@mui/material";
import { isEmpty } from "lodash";
import PSGraph from "../PSGraph";
import PTGraph from "../PTGraph";
import PCGraph from "../PCGraph";

export default function SummaryGraphs(props) {
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }} sx={{ mt: 1 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography sx={{ fontWeight: "bold", fontSize: 16.5 }}>
          Project Summary
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={1}>
          {!isEmpty(props.psData) &&
          !isEmpty(props.ptData) &&
          !isEmpty(props.pcData) ? (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{
                  display: "flex",
                  justifyContent: "Center",
                }}
              >
                <PSGraph data={props.psData} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ display: "flex", justifyContent: "Center" }}
              >
                <PTGraph data={props.ptData} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ display: "flex", justifyContent: "Center" }}
              >
                <PCGraph data={props.pcData} />
              </Grid>
            </>
          ) : (
            <Grid item>
              <Typography variant="body2" color="textPrimary">
                Chart data is not available.
              </Typography>
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
